'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { formatToReferencesList } from '../lib/formatReferences';
import get from 'transmute/get';
import http from 'hub-http/clients/apiClient';

// Analytics page id is more reliable than id
const formatter = formatToReferencesList({
  getId: get('analyticsPageId'),
  getLabel: get('name'),
  getDescription: get('url')
});

// The analyticsPageId is referred to as analyticsId from this endpoint
const searchFormatter = formatToReferencesList({
  getId: get('analyticsId'),
  getLabel: get('name'),
  getDescription: get('url')
});

// If multiple pages are found for a given analytic page id
export const removeDuplicates = responseObjects => {
  const hasSeenId = {};
  const duplicatesIds = [];
  responseObjects.forEach(({
    analyticsPageId
  }) => {
    if (hasSeenId[analyticsPageId]) {
      duplicatesIds.push(analyticsPageId);
    }
    hasSeenId[analyticsPageId] = true;
  });
  if (!duplicatesIds.length) {
    return responseObjects;
  }
  const indexesToRemove = [];
  duplicatesIds.forEach(id => {
    // prefer non-deleted pages
    const deletedPageIndex = responseObjects.findIndex(obj => {
      return obj.analyticsPageId === id && obj.deletedAt > 0;
    });
    if (deletedPageIndex > -1) {
      indexesToRemove.push(deletedPageIndex);
      return;
    }

    // prefer pages where the analytic page id and the id are the same
    const mismatchedIdPageIndex = responseObjects.findIndex(obj => {
      return obj.analyticsPageId === id && obj.id !== id;
    });
    if (mismatchedIdPageIndex > -1) {
      indexesToRemove.push(mismatchedIdPageIndex);
      return;
    }
  });
  return responseObjects.filter((_, i) => !indexesToRemove.includes(i));
};
export const createFetchByIds = ({
  httpClient
}) => ids => httpClient.get('content/api/v4/contents', {
  query: {
    analyticsPageId__in: ids.join(','),
    includeDeleted: true,
    limit: 2 * ids.length // including deleted pages means some pages will have duplicates
  }
}).then(response => List(removeDuplicates(response.objects))).then(response => formatter(response));
export const fetchByIds = createFetchByIds({
  httpClient: http
});
export const createFetchSearchPage = ({
  httpClient
}) => opts => httpClient.get('contentsearch/v2/search/internal', {
  query: {
    type: ['LANDING_PAGE', 'SITE_PAGE', 'BLOG_POST', 'LISTING_PAGE'],
    limit: get('count', opts) || 100,
    offset: get('offset', opts) || 0,
    term: get('query', opts) || ''
  }
}).then(response => {
  const {
    objects = [],
    offset,
    totalCount
  } = response;
  return ImmutableMap({
    count: objects.length,
    hasMore: offset + objects.length < totalCount,
    offset: offset + objects.length,
    results: searchFormatter(objects),
    total: totalCount
  });
});
export const fetchSearchPage = createFetchSearchPage({
  httpClient: http
});